<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div
    class="layout__container__bottom d-flex flex-row justify-content-end align-items-center mt-3 pb-8"
>
    <span
        (click)="swal()"
        class="layout__container__bottom__cancel me-4 pe-2"
        tabindex="1100"
        >{{ 'fe_precheckin_layout_container_bottom_href' | translate }}</span
    >
    <div
        (click)="onClick()"
        (keydown.enter)="onKeydown($event)"
        (keydown.space)="onKeydown($event)"
        tabindex="1101"
    >
        <fe-button
            class="layout__container__bottom__button d-grid"
            [btnClass]="'d-flex justify-content-center align-items-center'"
            [style]="'primary'"
            [disabled]="disabled"
            [loading]="loading"
        >
            <span
                class="layout__container__bottom__button__span px-4"
                *ngIf="!loading"
                >{{
                    'fe_precheckin_layout_container_bottom_button' | translate
                }}</span
            >
        </fe-button>
    </div>
</div>
<div
    class="layout__container__two row justify-content-end align-items-center mt-3 pb-4 pb-md-8"
>
    <div
        (click)="onClick()"
        (keydown.enter)="onKeydown($event)"
        (keydown.space)="onKeydown($event)"
        tabindex="1102"
    >
        <fe-button
            class="layout__container__two__button d-grid col-12"
            [btnClass]="'d-flex justify-content-center align-items-center'"
            [style]="'primary'"
            [disabled]="disabled"
            [loading]="loading"
        >
            <span
                class="layout__container__two__button__span px-4"
                *ngIf="!loading"
                >{{
                    'fe_precheckin_layout_container_bottom_button' | translate
                }}</span
            >
        </fe-button>
    </div>
    <span
        (click)="swal()"
        class="layout__container__two__cancel col-12 mt-2 text-center"
        tabindex="1103"
        >{{ 'fe_precheckin_layout_container_bottom_href' | translate }}</span
    >
</div>

<swal
    #precheckinTemplateButtons
    [showConfirmButton]="true"
    [showCancelButton]="true"
    [confirmButtonText]="confirmButtonText"
    [cancelButtonText]="cancelButtonText"
    [customClass]="{ popup: 'custom-swal-popup-cancel' }"
    [showCloseButton]="true"
>
    <div *swalPortal="undefined">
        <div class="cancel container-fluid">
            <span class="cancel__title">{{
                'fe_precheckin_layout_swal_title' | translate
            }}</span>
            <span class="cancel__subtitle"
                >{{ 'fe_precheckin_layout_swal_subtitle' | translate }}
            </span>
        </div>
    </div>
</swal>
